import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const RoleService = {
  getList: async () => {
    const response = await apiService.get("/roles");
    console.log(response);
    return response.data;
  },
  getRoles: async () => {
    const response = await apiService.get("/rolesmenus/grouped");
    console.log(response);
    return response.data;
  },
  create: async (data) => {
    const response = await apiService.post("/roles", data);
    return response.data;
  },

  update: async (id, updatedData) => {
    const response = await apiService.put(`/roles/${id}`, updatedData);
    return response.data;
  },

  getbyId: async (id) => {
    const response = await apiService.get(`/roles/${id}`);

    return response.data;
  },
  deleteRole: async (id) => {
    console.log(id);
    const response = await apiService.delete(`/roles/${id}`);
    console.log("called", response);
    return response.data;
  },
};
export default RoleService;
